export default class ParseAndCompleteHtml {
  constructor(html) {
    // 初始str
    this.originHtml = html
    this.html = html
    this.ncname = `[a-zA-Z_][\\-\\.0-9_a-zA-Z]*`
    this.qnameCapture = `((?:${this.ncname}\\:)?${this.ncname})`
    this.startTagOpen = new RegExp(`^<${this.qnameCapture}`) // 标签开头的正则 捕获的内容是标签名
    this.endTag = new RegExp(`^<\\/${this.qnameCapture}[^>]*>`) // 匹配标签结尾的 </div> 自闭合标签不用添加到stack里
    this.attribute =
      /^\s*([^\s"'<>\\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/ // 匹配属性的
    this.startTagClose = /^\s*>/ // 匹配标签结束的 >  只匹配双标签，不匹配自闭合标签<xxx />，因为自闭合标签不用补全
    this.commentPattern = /<!--[\w\W\r\n]*?-->/gim // html注释，先将传入的字符串的注释去掉
    this.stack = [] // 存放已匹配的标签
    this.singleEndTag = [] // 存放剩余的结束标签
  }
  // 箭头函数处理this
  start(tagName) {
    this.stack.push(tagName)
  }

  end(tagName) {
    // 当stack中有对应的tag，取出
    // 如果stack中已经没有tag，说明是尾部有多余的tag结束标签，没有与之匹配的开始标签
    this.stack.length > 0 ? this.stack.pop() : this.singleEndTag.push(tagName)
  }
  // 不停从左到右解析html
  advance(n) {
    this.html = this.html.substring(n)
  }
  parseStartTag() {
    let start = this.html.match(this.startTagOpen)
    if (start) {
      // 获取tagName
      const matchTagName = start[1]
      this.advance(start[0].length) // 将标签删除
      let end, attr
      while (
        !(end = this.html.match(this.startTagClose)) &&
        (attr = this.html.match(this.attribute))
      ) {
        // 将属性进行解析
        this.advance(attr[0].length) // 将属性去掉
      }
      if (end) {
        // 去掉开始标签的 >
        this.advance(end[0].length)
        return matchTagName
      }
    }
  }
  getStack() {
    return this.stack
  }
  getSingleEndTag() {
    return this.singleEndTag
  }
  // 清除html注释
  clearComment() {
    if (this.html) {
      this.html = this.html.replace(this.commentPattern, '')
    }
    return this.html
  }
  parseHTML() {
    // 不停的从左至右去解析html字符串
    while (this.html) {
      let textEnd = this.html.indexOf('<')
      if (textEnd == 0) {
        // 如果当前索引为0 肯定是一个标签 开始标签 结束标签
        let startTagMatch = this.parseStartTag() // 通过这个方法获取到匹配的结果 tagName
        if (startTagMatch) {
          this.start(startTagMatch) // 1解析开始标签
          continue // 如果开始标签匹配完毕后 继续下一次 匹配
        }
        let endTagMatch = this.html.match(this.endTag)
        if (endTagMatch) {
          this.advance(endTagMatch[0].length)
          this.end(endTagMatch[1]) // 2解析结束标签
          continue
        }
      }
      let text
      if (textEnd >= 0) {
        text = this.html.substring(0, textEnd)
      } else {
        // 解决只剩text的情况，例如 “<div>只剩文本”解析完div后只剩下“只剩文本”，textEnd=-1，直接将html赋值给text
        text = this.html
      }
      // 解析文本
      if (text) {
        this.advance(text.length)
      }
    }
  }
  completeTag() {
    let completedStr = this.originHtml
    completedStr = this.clearComment()
    this.parseHTML()
    // 有结束标签未匹配上
    if (this.singleEndTag.length > 0) {
      for (let i = 0; i < this.singleEndTag.length; i++) {
        let itemTag = this.singleEndTag[i]
        completedStr = `<${itemTag}>${completedStr}`
      }
    }
    if (this.stack.length > 0) {
      for (let i = this.stack.length; i >= 0; i--) {
        let itemTag = this.stack[i]
        completedStr = `${completedStr}</${itemTag}>`
      }
    }
    return completedStr
  }
}
